// extracted by mini-css-extract-plugin
module.exports = {"link":"proposition_link__g_m5N","focus-visible":"proposition_focus-visible__iY_Kf","js-focus-visible":"proposition_js-focus-visible__WQoyh"};